import { Cog, CopyCheck } from "lucide-react";
function useCalculateSimilarity() {
  const calculateSimilarity = (str1, str2) => {
    // Noktalama işaretlerini ve fazla boşlukları temizle (örn. sonradan gelen "." karakteri için)
    const cleanStr1 = str1
      .toLowerCase()
      .replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g, "")
      .trim();
    const cleanStr2 = str2
      .toLowerCase()
      .replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g, "")
      .trim();

    // Tam eşleşme kontrolü (Noktalama temizlendiği için artık %100 eşleşebilir)
    if (cleanStr1 === cleanStr2) return 1;

    // Kelime bazlı karşılaştırma (özellikle speech recognition için)
    const words1 = cleanStr1.split(/\s+/);
    const words2 = cleanStr2.split(/\s+/);

    // Eğer tek kelime karşılaştırması yapılıyorsa
    if (words2.length === 1) {
      const targetWord = words2[0];
      const spokenWords = words1.join(" ");

      // Konuşulan kelime hedef kelimeyle birebir aynıysa
      if (spokenWords === targetWord) {
        return 1;
      }

      // Hedef kelime konuşulan metnin içinde geçiyorsa
      if (spokenWords.includes(targetWord)) {
        return 0.95;
      }

      // Veya tam tersi
      if (targetWord.includes(spokenWords)) {
        return 0.9;
      }
    }

    const len1 = cleanStr1.length;
    const len2 = cleanStr2.length;

    if (len1 === 0 && len2 === 0) return 1;
    if (len1 === 0 || len2 === 0) return 0;

    // Levenshtein Distance
    const matrix = Array(len1 + 1)
      .fill(null)
      .map(() => Array(len2 + 1).fill(0));

    for (let i = 0; i <= len1; i++) matrix[i][0] = i;
    for (let j = 0; j <= len2; j++) matrix[0][j] = j;

    for (let i = 1; i <= len1; i++) {
      for (let j = 1; j <= len2; j++) {
        const cost = cleanStr1[i - 1] === cleanStr2[j - 1] ? 0 : 1;
        matrix[i][j] = Math.min(
          matrix[i - 1][j] + 1,
          matrix[i][j - 1] + 1,
          matrix[i - 1][j - 1] + cost,
        );
      }
    }

    const distance = matrix[len1][len2];
    const maxLen = Math.max(len1, len2);

    // Normalize edilmiş skor
    const similarity = maxLen === 0 ? 1 : 1 - distance / maxLen;

    // Kısa kelimeler için tolerans artır
    if (len2 <= 5 && similarity >= 0.6) {
      return Math.min(similarity + 0.2, 1);
    }

    return similarity;
  };

  const getSimilarityColor = (score) => {
    if (score >= 0.8) return "text-green-600";
    if (score >= 0.6) return "text-yellow-600";
    return "text-red-600";
  };

  const getFeedbackMessage = (score) => {
    if (score >= 0.9) return "Mükemmel! 🎉";
    if (score >= 0.8) return "Çok iyi! 👍";
    if (score >= 0.7) return "İyi! 👏";
    if (score >= 0.6) return "Fena değil! 😊";
    return "Tekrar deneyin! 🔄";
  };

  return { calculateSimilarity, getFeedbackMessage, getSimilarityColor };
}

export default useCalculateSimilarity;
